module.exports = __webpack_public_path__ + "img/129.305fbcb3.jpg";